var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-recaptcha',{ref:"recaptcha",attrs:{"sitekey":this.sitekey,"load-recaptcha-script":"","type":"login"},on:{"verify":_vm.onVerify,"expired":_vm.onExpired,"render":_vm.onRender,"error":_vm.onError}})}
var staticRenderFns = []

export { render, staticRenderFns }